import React, {useState } from "react";
import Header from "../header/header";

import CustomDrawer from '../custom-drawer/custom-drawer'


const Layout = ({ children }) => {
  const [open, setopen] = useState(true)
  const toggleOpen = () => {
    setopen(!open)
  }
  return (
    <div className="dashboard-admin" >
      <div className={open ? "dashboard-sidebar" : "open-sidebar"}>
        <CustomDrawer />
      </div>
      <div className={open ? "inner-content-bottom" : "open-innerbar"}>
        <div className="top-header">
          <Header toggleOpen={toggleOpen} />
        </div>
        <div className="content-inner">
          {children}
        </div>

      </div>
    </div>
  );
};

export default Layout;
